var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      staticStyle: { "margin-left": "16px" },
      attrs: {
        placement: "bottom",
        width: "330",
        trigger: "hover",
        "popper-class": "notice-center",
      },
      on: { "after-leave": _vm.readMessage },
    },
    [
      _c("div", { staticClass: "notice-header" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("system::common::dialog::message_manage")) + " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "notice-list" },
        [
          _vm._l(_vm.messageList, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "item",
                on: {
                  click: function ($event) {
                    return _vm.handle(item, "message")
                  },
                },
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "iconfont iconxitongxiaoxi1" }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "container",
                    class: { disable: !!item.status },
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("div", { staticClass: "title-name" }, [
                        _vm._v(_vm._s(item.header)),
                      ]),
                      _c("div", { staticClass: "title-time" }, [
                        _vm._v(_vm._s(item.pushTime.slice(0, -3))),
                      ]),
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(" " + _vm._s(item.message) + " "),
                    ]),
                  ]
                ),
              ]
            )
          }),
          _vm._l(_vm.noticeList, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "item",
                on: {
                  click: function ($event) {
                    return _vm.handle(item, "notice")
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "icon",
                    staticStyle: { background: "#ffeedf" },
                  },
                  [_c("i", { staticClass: "iconfont icongonggao1" })]
                ),
                _c(
                  "div",
                  {
                    staticClass: "container",
                    class: { disable: !!item.status },
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("div", { staticClass: "title-name" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _c("div", { staticClass: "title-time" }, [
                        _vm._v(_vm._s(item.pubtime.slice(0, -3))),
                      ]),
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(" " + _vm._s(item.content) + " "),
                    ]),
                  ]
                ),
              ]
            )
          }),
          _vm.messageList && _vm.noticeList
            ? [
                _c("default-data", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !(_vm.messageList.length + _vm.noticeList.length),
                      expression: "!(messageList.length + noticeList.length)",
                    },
                  ],
                  staticStyle: { height: "200px" },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "notice-footer",
          on: {
            click: function ($event) {
              return _vm.$router.push("/message-center")
            },
          },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("system::common::dialog::message_more")) + " "
          ),
        ]
      ),
      _c(
        "el-badge",
        {
          attrs: {
            slot: "reference",
            value: _vm.count,
            "is-dot": "",
            hidden: !_vm.count,
            max: 99,
          },
          slot: "reference",
        },
        [
          _c("div", { staticClass: "header-iconMessage" }),
          _c("showDetail", {
            attrs: { message: _vm.message },
            on: { closed: _vm.close },
            model: {
              value: _vm.isShowDetail,
              callback: function ($$v) {
                _vm.isShowDetail = $$v
              },
              expression: "isShowDetail",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }